import { Project } from '../../types';

export interface IAgGridRadio {
  isSelected: boolean;
  project: Project;
  callback: (any?) => void;
}

export class RadioButtonCellRendered {
  content: HTMLInputElement;
  params: IAgGridRadio;

  init(params: IAgGridRadio) {
    this.params = params;
    this.content = document.createElement('zero-radio') as HTMLInputElement;
    this.content.setAttribute('part', 'iconWrapper');
    this.content.checked = this.params.isSelected;
    this.content.addEventListener('click', () => {
      this.params.callback(this.params.project);
    });
  }

  getGui(): HTMLElement {
    return this.content;
  }

  refresh(): boolean {
    return false;
  }
}
